import React, { useCallback, useContext, useMemo } from 'react';
import useTranslations from '../../hooks/useTranslations';
import FormBuilderCustomButtonCardView from '../view/FormBuilderCustomButtonCardView';
import {
  CustomButtonsContext,
  SYSTEM_BUTTONS_DEFAULT_SCHEMA,
  INTEGRATION_BUTTONS_DEFAULT_SCHEMA,
  BUTTONS_THAT_CANT_BE_DISABLED
} from './FormBuilderCustomButtonsEngine';
import { FormBuilderContext } from './FormBuilderEngine';
import { getButtonCategory } from './FormBuilderCustomButtonsEngine';

const FormBuilderCustomButtonCardEngine = ({
  buttonData = {},
  isIntegrationButton
}) => {
  const { form } = useContext(FormBuilderContext);

  const t = useTranslations();

  const noDisable = BUTTONS_THAT_CANT_BE_DISABLED.indexOf(buttonData.id) !== -1;

  const getStatusesColumnData = useCallback(() => {
    const allStatuses =
      buttonData.statuses === 'all' ||
      (buttonData.statuses.length === 1 && buttonData.statuses[0] === 'all') ||
      form.customStatuses.every(
        cs =>
          buttonData.statuses.find(bs => bs === cs.internalId) &&
          buttonData.statuses.includes('new')
      );

    if (allStatuses) {
      return [t('systemBtn.statuses.all'), ''];
    }

    const statusesNames = buttonData.statuses
      .map(s => {
        if (s === 'new' && buttonData.id !== 'REQUEST_MORE_INFO') {
          return t('customButtons.wizard.select.status.new');
        }
        const status = form.customStatuses.find(cs => cs.internalId === s);
        return status ? status.label : null;
      })
      .filter(sn => sn !== null);

    if (statusesNames.length <= 1) {
      return [statusesNames[0] || t('systemBtn.statuses.none'), ''];
    }

    return [`${statusesNames[0]}, ...`, statusesNames.join(', ')];
  }, [form, buttonData]);

  const getAutomationsUsage = useCallback(
    _btnId => {
      const automationsIdTranslationsMap = {
        // match automations trigger names to system buttons ids
        [SYSTEM_BUTTONS_DEFAULT_SCHEMA.SIGN_AND_SUBMIT.id]: 'submitted',
        [INTEGRATION_BUTTONS_DEFAULT_SCHEMA.SUBMIT_AND_THIRDFORT.id]:
          'submitted',
        [SYSTEM_BUTTONS_DEFAULT_SCHEMA.SUBMIT.id]: 'submitted',
        [SYSTEM_BUTTONS_DEFAULT_SCHEMA.SAVE_CHANGES.id]: 'admin_save_changes',
        [SYSTEM_BUTTONS_DEFAULT_SCHEMA.REQUEST_MORE_INFO.id]:
          'request_more_info'
      };

      const buttonId = automationsIdTranslationsMap[_btnId] || _btnId;
      const automations = form.automations || [];
      const automationsUsingBtn = [];

      automations.forEach(a => {
        if (
          a.rule &&
          a.rule.when &&
          (a.rule.when.eventType === buttonId ||
            (a.rule.when.eventType === 'cb' &&
              a.rule.when.eventInfo === buttonId))
        ) {
          // we could remove the eventType check but it's there for safty purposes
          automationsUsingBtn.push(a);
        }
      });
      return automationsUsingBtn;
    },
    [form]
  );

  const automationsUsingBtn = useMemo(
    () => getAutomationsUsage(buttonData.id),
    [buttonData]
  );

  const viewProps = {
    getStatusesColumnData,
    automationsUsingBtn,
    buttonCategory: getButtonCategory(buttonData),
    isIntegrationButton,
    buttonData,
    disabled: !buttonData.statuses || !buttonData.statuses.length,
    noDisable,
    ...buttonData
  };

  return <FormBuilderCustomButtonCardView {...viewProps} />;
};

export default FormBuilderCustomButtonCardEngine;
